import { siteAsset } from "../../../utils/siteBase";

// Product brochure PDFs live in the main site's /assets folder. siteAsset()
// prefixes the deployment base path so they resolve under a sub-folder too.
export const aiDocLink                      = siteAsset("/assets/pdf/CHATBOT.pdf");
export const callAnalyticsDocLink           = siteAsset("/assets/pdf/CallBack_Assist_Module_2018.pdf");
export const callBackDocLink                = siteAsset("/assets/pdf/CallBack_Assist_Module_2018.pdf"); // Reusing assist module for callback
export const coBrowserDocLink               = siteAsset("/assets/pdf/INAIPI_Click_to_Call.pdf"); // Closest match
export const crmDocLink                     = siteAsset("/assets/pdf/Imperium_CRM_Connect.pdf");
export const dccDocLink                     = siteAsset("/assets/pdf/ICEP.pdf"); // Closest match for contact center digital
export const qmsDocLink                     = "";
export const outBoundDocLink                = "";
export const smartRuleEngineDocLink         = "";
export const smartSurveyDocLink             = siteAsset("/assets/pdf/CallBack_Assist_Module_2018.pdf");
export const smsDocLink                     = siteAsset("/assets/pdf/INAIPI_Click_to_Call.pdf");
export const socialEngagementDocLink        = siteAsset("/assets/pdf/Social-media.pdf");
export const ticketingDocLink               = "";
export const videoKycDocLink                = "";
export const socialMediaConnectorDocLink    = siteAsset("/assets/pdf/Social-media.pdf");
